/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class capitalequityjournal extends IceEntity {
  capital_equity_journal_key: string = "";
  other_items_key: string = "";
  other_items_receiving_key: string = "";
  medical_service_key: string = "";
  service_payment_reference_key: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  last_name: string = "";
  coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  journal_date: any = NaN;
  journal_desc: string = "";
  quantity: number = 0.0;
  debit: number = 0.0;
  credit: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accounting_period_key: string = "";
  entry_type: IceTypes.journal_entry_type.jetGeneral;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CAPITAL_EQUITY_JOURNAL";
  }
}
